module.exports = __webpack_public_path__ + "img/4.834a33db.png";